<template>
  <div class="resultForm">
    <div class="stateBg">
      <img src="@/assets/imgs/signSuccess.png" alt="" />
    </div>
    <div class="state">认证成功</div>
    <div class="tag" v-if="callBack || wxCallBack">
      {{ timer }}s后返回
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: 3,
      timerId: null,
    }
  },

  created() {
    this.timerId = setInterval(() => {
      this.timer--

      if (this.timer <= 0) {
        clearInterval(this.timerId)
        if (this.callBack) {
          // 打开url地址
          window.location.href = this.callBack
        } else if (this.wxCallBack) {
          window.wx.miniProgram.redirectTo(this.wxCallBack)
        }
      }
    }, 1000)
  },

  beforeDestroy() {
    clearInterval(this.timerId)
  },

  computed: {
    // H5回调地址
    callBack() {
      const { callBack = '' } = this.$route.query
      if (callBack) {
        if (callBack === 'null' || callBack === 'undefined') {
          return ''
        }
        return decodeURIComponent(callBack)
      }
      return decodeURIComponent(callBack)
    },

    // 小程序回调地址
    wxCallBack() {
      const { wxCallBack = '' } = this.$route.query
      if (wxCallBack) {
        if (wxCallBack === 'null' || wxCallBack === 'undefined') {
          return ''
        }
        return decodeURIComponent(wxCallBack)
      }
      return decodeURIComponent(wxCallBack)
    },
  },

  mounted() {
    // this.timer = setInterval(() => {
    // this.$router.back()
    // }, 3000)
  },
}
</script>

<style lang="less" scoped>
.resultForm {
  padding-top: 76px;

  .stateBg {
    width: 100%;
    text-align: center;
    margin-bottom: 16px;

    img {
      width: 120px;
    }
  }

  .state {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: bold;
    color: #111a34;
    text-align: center;
    line-height: 24px;
    margin-bottom: 4px;
  }

  .tag {
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #677283;
    line-height: 24px;
  }

  .button-group {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
